import { Box, Grid2, Typography } from "@mui/material";
import React from "react";

const ViewApprovers = ({ tender }) => {
  return (
    <Box className="dashboard-container" px={10}>
      <Typography variant="h6">Approvers</Typography>
      <Grid2 container>
        <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid" sx={{borderTop: '1px solid #000'}}>
          BUYER
        </Grid2>
        <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid" sx={{borderTop: '1px solid #000', borderRight: '1px solid #000'}}>
          {tender.orgUser.name}
        </Grid2>
        {tender &&
          tender.approvers.map((approver, i) => (
            <React.Fragment key={i}>
              <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
                {approver?.approver?.userRoleName.replace("_", " ")}
              </Grid2>
              <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid" sx={{borderRight: '1px solid #000'}}>
                {approver.approver.name}
              </Grid2>
            </React.Fragment>
          ))}
        {tender &&
          tender.tenderAwardees.map((awardee, i) => (
            <React.Fragment key={i}>
              <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
                FINAL APPROVER 1
              </Grid2>
              <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid" sx={{borderRight: '1px solid #000'}}>
                {awardee?.awardee1?.name}
              </Grid2>
              <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
                FINAL APPROVER 2
              </Grid2>
              <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid" sx={{borderRight: '1px solid #000'}}>
                {awardee.awardee2.name}
              </Grid2>
            </React.Fragment>
          ))}
      </Grid2>
    </Box>
  );
};

export default ViewApprovers;
